import { McAction } from '../IMcAction';
import initialState, { IOnBoardingState } from '../modules/onboarding/IOnboardingState';
import {
    LOAD_ONBOARDING_SUCCESSFUL, UPDATE_HEADER_INFO, UPDATE_SIDE_PANEL_SELECTED_TAB,
    SELECT_ANALYTE, SELECT_INSTRUMENT, UPDATE_ALL_INSTRUMENT_ANALYTES,
    UPDATE_ANALYTE,
    SAVE_ANALYTES_STARTS,
    SAVE_ANALYTES_SUCCESSFUL,
    SAVE_ANALYTES_DONE,
    UNDO_ANALYTE_CHANGES,
    CHECKED_ANALYTE,
    UNCHECKED_ALL_ANALYTE
} from '../modules/onboarding/onboarding.const';
import {
    loadOnboardingSuccessful, resetOnboarding, updateHeaderInfo,
    updateSidePanelSelectedTab,
    selectInstrument,
    selectAnalyte,
    updateAnalytesWithInputData,
    saveAnalytesStarts,
    saveAnalytesSuccessful,
    saveAnalytesDone,
    undoAnalyteChanges,
    checkedAnalyte,
    uncheckedAllAnalytes
} from '../modules/onboarding/onboarding.reducer.logic';
import { CLEAR_CURRENT_LAB } from '../modules/lab/lab.action.const';


export function onboardingReducer(state: IOnBoardingState = initialState, action: McAction) {
    switch (action.type) {
        case LOAD_ONBOARDING_SUCCESSFUL:
            return loadOnboardingSuccessful(state, action);
        case CLEAR_CURRENT_LAB:
            return resetOnboarding(state, action);
        case UPDATE_HEADER_INFO:
            return updateHeaderInfo(state, action);
        case UPDATE_SIDE_PANEL_SELECTED_TAB:
            return updateSidePanelSelectedTab(state, action);
        case SELECT_INSTRUMENT:
            return selectInstrument(state, action);
        case SELECT_ANALYTE:
            return selectAnalyte(state, action);
        case UPDATE_ALL_INSTRUMENT_ANALYTES:
        case UPDATE_ANALYTE:
            return updateAnalytesWithInputData(state, action);
        case UNDO_ANALYTE_CHANGES:
            return undoAnalyteChanges(state, action);
        case CHECKED_ANALYTE:
            return checkedAnalyte(state, action);
        case UNCHECKED_ALL_ANALYTE:
            return uncheckedAllAnalytes(state, action);
        case SAVE_ANALYTES_STARTS:
            return saveAnalytesStarts(state, action);
        case SAVE_ANALYTES_SUCCESSFUL:
            return saveAnalytesSuccessful(state, action);
        case SAVE_ANALYTES_DONE:
            return saveAnalytesDone(state, action);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/reducers/onboarding.reducer.ts